import React from 'react';
import TopPanel from "./toppanel.js";
import CheckListView from "./checklists/checklistview.js";
import EditDocument from "./EditDocument.js";
import Modal from './modal.js';

module.exports = React.createClass({
    success: function(reply) {
        for (var i in reply.data)
            reply.data[i].content = HC_GetDocumentContent(reply.data[i].content);
        HC_SetDataAndSelectedItem(this, reply.data);
        if (this.state.needGoBack) {
            this.goBack();
        }
    },
    loadFromServer: function(id=null) {
        HC_SendRequest("documents", null, this.success);
    },
    getInitialState: function() {
        return {
            data: [],
            selectedId: null,
            editMode: false,
            goBackEnabled: false,
            needGoBack: false,
            noData: true,
            orderMode: false,
            maxSize: 20*1024*1024,
            uploadXhr: null
        }
    },
    componentWillMount: function() {
        HC_CheckLoginAndAcc(this, HC_AccAdmin);
    },
    componentDidMount: function() {
        HC_RestoreNavPanel();
        HC_SelectNavItem("li-documents");
        this.loadFromServer();

        HC_SubscribeHammerEvent(this.refs.panel, "swiperight", this.goBack);
    },
    componentWillUnmount: function () {
        HC_UnsubscribeHammerEvent(this.refs.panel, "swiperight");
    },
    getItemCaption: function(o) {
        return o.name;
    },
    getItemText: function(o) {
        if (o.id == -1)
            return (null);
        var i = 0;
        var strings = [];
        strings.push(HC_LANG.DOC_EDITED + " " + HC_FormatDateFull(new Date(parseInt(o.edited))));
        if (o.created)
            strings.push(HC_LANG.DOC_CREATED + " " + HC_FormatDateFull(new Date(parseInt(o.created))));
        if (o.created_by)
            strings.push(HC_LANG.DUE_BY + " " + o.created_by);
        var items = strings.map(function(s) {return (<div className="qqq" key={i++}>{s}</div>);});
        return <div>{items}</div>;
    },
    handleOnSelected: function(e) {
        var id = parseInt(e);
        var deviceType = HC_DeviceType();
        this.setState({selectedId: id, mode: 0, goBackEnabled: deviceType  == HC_CONST.SCR_PHONE});
        if (deviceType == HC_CONST.SCR_PHONE )
            HC_SwitchRPanel();
    },
    handleCreateDocClicked: function(){
        this.createEditDocument(true);
    },
    handleEditDocClicked: function(){
        this.createEditDocument(false);
    },
    createEditDocument: function(isNew){
        if (isNew) {
            if (this.state.data.length > 0 && this.state.data[0].id == -1)
                return;
        }
        var deviceType = HC_DeviceType();

        var state = {editMode: true, goBackEnabled: deviceType != HC_CONST.SCR_DESCKTOP};
        if (isNew) {
            state.doc = {id: -1, name: '', content: ''};
            this.state.data.unshift(state.doc);
            this.state.selectedId = state.selectedId = -1;
        } else {
            var doc = HC_CurrentItem(this);
            state.doc = {id: doc.id, name: doc.name, content: doc.content};
        }
        this.setState(state);
        if (deviceType == HC_CONST.SCR_DESCKTOP){
            this.showEditModal(isNew);
        }
    },
    showEditModal: function(isNew) {
        var doc = HC_CurrentItem(this);
        HC_ShowModal(EditDocument, {id: doc.id, name: doc.name, content: doc.content, files: doc.files ? doc.files : [], cancel:this.goBack, save:this.handleSaveDocModal, canModalExit:this.canModalExit, sendFileRequest:this.sendFileRequest, maxSize:this.state.maxSize});
    },
    canModalExit: function() {
        return !this.state.needGoBack;
    },
    handleSaveDocModal: function(data){
        var action = data.id == -1 ? "add_document" : "edit_document";
        data.files = ['22345200-abe8-4f60-90c8-0d43c5f6c0f6'];
        this.setState({needGoBack: true});
        HC_SendRequest(action, data, this.success, null);
    },
    handleSaveDocClicked: function(){
        if (!this.state.doc.name || this.state.doc.name.trim().length == 0 ) {
            $('#createdoccaption-input').addClass('hc-has-error');
        }
        else
        {
            $('.input').removeClass('hc-has-error');
            var action = this.state.data[0].id == -1 ? "add_document" : "edit_document";
            this.setState({needGoBack: true});
            HC_SendRequest(action, this.state.doc, this.success, null);
        }
    },
    goBack: function(){
        HC_CloseModal();
        HC_RestoreRPanel();
        this.internalGoBack();
    },
    internalGoBack: function(){
        var state = {editMode: false, doc: null, needGoBack: false, goBackEnabled: false};
        if (this.state.data.length > 0 && this.state.data[0].id == -1) {
            this.state.data.shift();
            state.selectedId = this.state.data.length > 0 ? this.state.data[0].id : null;
            for (var i=0; i<this.state.data.length; i++)
                if (this.state.data[i].content !== undefined)
                    state.selectedId = this.state.data[i].id;
        }
        this.setState(state);
    },
    documentChanged(o) {
        this.state.doc[o.target.getAttribute('data-key')] = o.target.value;
        this.setState({doc: this.state.doc});
    },
    handleDeleteDocClicked: function () {
        var document = HC_CurrentItem(this);
        if (document)
            return HC_Confirm(HC_LANG.CHL_DELETE + ' "' + document.name + '"?', HC_LANG.CHL_DELETE, HC_LANG.DUE_CANCEL).then((function (_this) {
                return function () {
                    _this.commandCounter++;
                    _this.setState({disableActions: true, needGoBack: true});
                    HC_SendRequest('delete_document', {id: parseInt(document.id)}, _this.success);
                };
            })(this));
    },
    handleSetOrder: function() {
        this.setState({orderMode: true, selectedId: null});
    },
    handleFinishSetOrder: function() {
        this.setState({orderMode: false});
    },
    setOrderUp: function(documentId) {
        var a = this.state.data;
        var temp;
        for (var i=0; i<a.length; ++i) {
            if (a[i].id == documentId) {
                if (i === 0)
                    return; // first element can't be moved up
                temp = a[i-1];
                a[i-1] = a[i];
                a[i] = temp;
                this.setState({data: a, selectedId: parseInt(documentId)});
                break;
            }
        }
        this.commandCounter++;
        HC_SendRequest('set_document_order', {document_id: parseInt(documentId), up: 1}, this.success);
    },
    setOrderDown: function(documentId) {
        var a = this.state.data;
        var temp;
        for (var i=0; i<a.length; ++i) {
            if (a[i].id == documentId) {
                if (i === a.length-1)
                    return; // last element can't be moved down
                temp = a[i+1];
                a[i+1] = a[i];
                a[i] = temp;
                this.setState({data: a, selectedId: parseInt(documentId)});
                break;
            }
        }
        this.commandCounter++;
        HC_SendRequest('set_document_order', {document_id: parseInt(documentId), up: 0}, this.success);
    },
    deleteFile: function(ev) {
        var path = ev.target.getAttribute('data-key');
        var doc = HC_CurrentItem(this);
        if (!doc || !doc.files)
            return;
        var filteredFile = doc.files.filter(function(f){return f.path==path});
        if (filteredFile.length !== 1)
            return;

        var deleteFunc = function () {
            doc.files.splice(doc.files.indexOf(filteredFile[0]), 1);
            this.setState({data: this.state.data});
            HC_SendRequest('delete_file', {path: path}, this.loadFromServer);
        }.bind(this);

        if (filteredFile[0].state === 'error' || filteredFile[0].state === 'upload') {
            this.abortUpload();
            deleteFunc();
        } else {
            HC_Confirm(HC_LANG.DOC_DELETE_FILE + ' "' + filteredFile[0].name + '"?', HC_LANG.DOC_DELETE_STR).then(deleteFunc);
        }
    },
    handleAttachFile: function(ev) {
        $('#hc-doc-send-file').click();
    },
    sendFile: function(e) {
        var input = e.target;
        if (input.files.length > 0) {
            var filePath = HC_Guid();
            if (input.files[0].size > this.state.maxSize) {
                HC_ShowMessage(HC_LANG.DOC_ERROR_BIG_FILE);
                return;
            }
            var doc = HC_CurrentItem(this);
            if (!doc.files)
                doc.files = [];
            doc.files.push({name: input.files[0].name, path: filePath, state: 'upload', fileInfo: input.files[0]});
            this.forceUpdate();
            this.sendFileRequest(filePath, input.files[0]);
            input.value = '';
        }
    },
    sendFileRequest: function(filePath, fileInfo, editDocObj) {
        var doc = HC_CurrentItem(this);
        var fileName = fileInfo.name;
        var reader = new FileReader();
        reader.onload = function(){
            var fData = new FormData();
            fData.append("hc_file", fileInfo);
            fData.append("hc_session_id", HC_GetSession());
            fData.append("hc_file_id", filePath);

            $.ajax({
                url: HC_GetSiteAddr() + 'upload',
                enctype: 'multipart/form-data',
                contentType: false,
                type: 'POST',
                processData: false,
                data: fData,
                cache: false,
                success: function (reply) {
                    if (editDocObj) {
                        // inside edit documents
                        var files = editDocObj.state.files.filter(function (f) {
                            return f.path == filePath
                        });
                        if (files.length === 1) {
                            files[0].state = 'done';
                            editDocObj.forceUpdate();
                        }
                    } else {
                        if (this.state.uploadXhr)
                            HC_SendRequest('edit_document', {id:doc.id, new_files:[filePath]}, this.success, function(){});
                        this.state.uploadXhr = null;
                    }
                }.bind(this),
                error: function(reply) {
                    if (editDocObj) {
                        var files = editDocObj.state.files.filter(function (f) {
                            return f.path == filePath
                        });
                        if (files.length === 1) {
                            files[0].state = 'error';
                            editDocObj.forceUpdate();
                        }
                    } else {
                        // documents on mobile
                        if (this.state.uploadXhr == null)
                            return;
                        this.state.uploadXhr = null;
                        var doc = HC_CurrentItem(this);
                        if (!doc || !doc.files)
                            return;
                        var filteredFiles = doc.files.filter(function (f) {
                            return f.path == filePath
                        });
                        if (filteredFiles.length != 1)
                            return;
                        filteredFiles[0].state = 'error';
                        this.forceUpdate();
                    }
                }.bind(this),
                xhr: function()
                {
                    var xhr = new window.XMLHttpRequest();
                    xhr.upload.addEventListener("progress", function(evt){
                        if (evt.lengthComputable) {
                            var percentComplete = Math.round(100*evt.loaded / evt.total);
                            $('#progress-count-' + filePath).text(percentComplete + '%');
                            if (editDocObj)
                                $('#progress-arc-' + filePath).attr('d', HC_DescribeArc(60, 48, 25, 0, percentComplete * 3.6));
                            else
                                $('#progress-arc-' + filePath).attr('d', HC_DescribeArc(30, 29, 15, 0, percentComplete * 3.6));
                        }
                    }, false);
                    this.state.uploadXhr = xhr;
                    return xhr;
                }.bind(this)
            });
        }.bind(this);
        reader.readAsArrayBuffer(fileInfo);
    },
    abortUpload: function() {
      if (this.state.uploadXhr) {
          this.state.uploadXhr.abort();
          this.state.uploadXhr = null;
      }
    },
    fileClick: function(ev) {
        var path = ev.target.getAttribute('data-key');
        var doc = HC_CurrentItem(this);
        if (!doc || !doc.files)
            return;
        var filteredFiles = doc.files.filter(function(f){return f.path==path});
        if (filteredFiles.length !== 1)
            return;
        var file = filteredFiles[0];
        if (!file.state) {
            HC_DownloadFile(path, file.name);
        } else if (file.state === 'error') {
            var newPath = HC_Guid();
            file.path = newPath;
            file.state = 'upload';
            this.forceUpdate();
            this.sendFileRequest(newPath, file.fileInfo);
        }
    },
    render: function() {
        var deviceType = HC_DeviceType();
        var contentClass = "hc-content-panel";
        var item = HC_CurrentItem(this);
        var emptyItem;
        if (!item) {
            emptyItem = true;
            item = {};
        }

        var ricon, licon, riconAction, header, showMenuText, control, liconAction, rbutton;
        var leftRicon, leftRiconAction, leftRButton;

        if (deviceType === HC_CONST.SCR_DESCKTOP) {
            leftRicon = "fa-plus-circle";
            leftRiconAction = this.handleCreateDocClicked;
        } else {
            leftRButton = {
                items: [
                    {
                        name: HC_LANG.DOC_CREATE_DOC,
                        action: this.handleCreateDocClicked,
                        icon: "fa-plus-circle"
                    },
                    {
                        name: HC_LANG.DOC_SET_ORDER,
                        action: this.handleSetOrder,
                        icon: "fa-sort-amount-desc "
                    }]
            };
        }

        licon = this.state.goBackEnabled ? "fa-angle-left" : "";
        if (this.state.editMode && deviceType != HC_CONST.SCR_DESCKTOP) {
            ricon = "fa-floppy-o";
            riconAction = this.handleSaveDocClicked;
            liconAction = this.goBack;

            if (deviceType !== HC_CONST.SCR_PHONE)
                showMenuText = true;
            var inputStyle = {borderColor: "#f2f2f2", borderRadius: "0", borderBottomStyle: "none", marginBottom: "0", height:'40px'};
            var textareaStyle = {borderColor:"#f2f2f2 !important", position:'absolute', top:'40px', bottom:0, borderRadius:0, width: "100%", resize:"none"};
            contentClass += ' hc-top-most';
            if (this.state.data[0].id == -1)
                header = HC_LANG.DOC_CREATE_DOC;
            else
                header = HC_LANG.DOC_EDIT_DOC;

            control = (
                <div ref="panel"
                     style={{position:'absolute', top:'60px', bottom: 0, left:0, right:0, marginTop:'-1px' }}>
                    <div style={{position:'relative', width: (deviceType == HC_CONST.SCR_PHONE ? "100%":"80%"), height:'100%', margin:'auto', marginBottom:'20px'}}>
                        <div>
                            <input id="createdoccaption-input" className="form-control hc-f3" style={inputStyle} type="text" data-key="name" value={this.state.doc.name} onChange={this.documentChanged}/>
                        </div>
                        <textarea className="form-control custom-control hc-f3" style={textareaStyle} data-key="content" value={this.state.doc.content} onChange={this.documentChanged} />
                    </div>
                </div>
            );

            if (this.state.needGoBack) {
                licon = ricon = '';
                showMenuText = false;
            }
        } else {
            // view mode
            header = item.name;
            if (deviceType != HC_CONST.SCR_DESCKTOP) {
                rbutton = {
                    items: [
                        {
                            name: HC_LANG.DOC_EDIT_DOC,
                            action: this.handleEditDocClicked,
                            icon: "fa-pencil"
                        },
                        {
                            name: HC_LANG.DOC_ATTACH_FILE,
                            action: this.handleAttachFile,
                            icon: "fa-file-o"
                        },
                        {
                            name: HC_LANG.DOC_DELETE_DOC,
                            action: this.handleDeleteDocClicked,
                            icon: "fa-trash-o"
                        }]
                };
                if (item.files && item.files.filter(function(f){return f.state === 'error' || f.state === 'upload'}).length > 0) {
                    rbutton.items[1].action = null;
                    rbutton.items[1].disabled = true;
                }
                ricon = null;
                riconAction = null;
                liconAction = this.goBack;
            }
            else {

                // desktop
                ricon = "fa-pencil";
                riconAction = this.handleEditDocClicked;

                licon = "fa-trash-o";
                liconAction = this.handleDeleteDocClicked;
            }

            var files;
            if (item.files && item.files.length > 0) {
                var i = 0;
                files = item.files.map(function(f){
                    var icon='fa-file-text-o hc-green', deleteIcon, iconElement, percents=null, textColor='#8a8d91', uploadAgain;
                    if (deviceType !== HC_CONST.SCR_DESCKTOP) {
                        deleteIcon = (<div className="hc-f2 fa fa-times hc-delete-file" onClick={this.deleteFile} data-key={f.path} style={{display:'inline-block', padding:'15px', flex:"0 0 auto", margin:'auto', marginLeft:0, marginRight:0, color:'#bfc7cd', paddingLeft:'20px'}}/>);
                    }
                    if (f.state === 'error') {
                        icon = 'hc-red fa-exclamation-circle';
                        uploadAgain = (<div className="hc-f5" data-key={f.path} style={{color:textColor}}>Tap to upload again</div>);
                    }
                    if (f.state === 'upload') {
                        textColor = 'rgba(138, 141, 145, 0.5)';
                        iconElement = (<div>
                            <svg style={{height:"58px", width:"58px"}}>
                                <g style={{fill:"none", stroke:"#30ae97", strokeWidth:"3"}}>
                                    <path id={'progress-arc-' + f.path}/>
                                </g>
                            </svg>
                        </div>);
                        percents = (<div id={'progress-count-' + f.path} className="hc-f5" data-key={f.path} style={{color:textColor}}>0%</div>);
                    } else {
                        iconElement = (<div className={'fa hc-f1 ' + icon} data-key={f.path} onClick={this.fileClick} style={{display:"inline-block", margin:'auto', padding:'15px', flex:"0 0 50px", cursor: 'pointer'}}/>);
                    }
                    return(
                        <div key={++i} className="hc-ba hc-file-link hc-flex-display" style={{display:"flex", height:'58px', width:'100%', marginTop:'2%', overflow:'hidden'}}>
                            {iconElement}
                            <div className="hc-f3" data-key={f.path} onClick={this.fileClick} style={{display:"inline-block", position:'relative', margin:'auto', flex:"0 0 auto", width: "CALC(100% - 100px)", color:textColor, overflow:'hidden'}}>
                                <div data-key={f.path} style={{display:"inline-block", whiteSpace:'nowrap', textOverflow:'ellipsis', width:'100%', overflow:'hidden', verticalAlign:'middle'}}>{f.name}</div>
                                {uploadAgain}
                                {percents}
                            </div>
                            {deleteIcon}
                        </div>
                    );
                }.bind(this));
            }

            control = (
                <div ref="panel" style={{textAlign:"left", position:'absolute', bottom:0, top:'60px', left:0, right:0}}>
                    <div className="hc-f3" style={{ position:"absolute", padding:"4%", paddingTop:"3%", top:0, bottom:0, left:0, right:0, overflowY: "auto", WebkitOverflowScrolling:'touch'}}>
                        <input id="hc-doc-send-file" type="file" className="hc-upload" accept='*' onChange={this.sendFile} style={{display:'none'}}/>
                        {files}
                        <div style={{paddingTop:'3%', marginBottom:'30px', whiteSpace: 'pre-wrap'}}>
                            {item.content}
                        </div>
                    </div>
                </div>);

            if (emptyItem) {
                licon = liconAction = ricon = riconAction = rbutton = null;
                header = HC_LANG.CHL_EMPTY;
            }
        }

        if (this.state.orderMode) {
            leftRButton = null;
            leftRicon = "fa-check-circle";
            leftRiconAction = this.handleFinishSetOrder;
        }

        var dataWithoutNewElement = this.state.data.filter(function(o){return o.id != -1});

        return (
            <div id="panel-checklists" style={{height:"100%", position:"relative"}}>
                <div className="hc-list-panel hc-br">
                    <TopPanel text={HC_LANG.DOC_CAPTION} ricon={leftRicon} licon="fa-bars" onLiconClick={HC_ToggleNavPanel} onRiconClick={leftRiconAction} rbutton={leftRButton}/>
                    <CheckListView data={dataWithoutNewElement} getCaption={this.getItemCaption} getText={this.getItemText} selectedId={this.state.selectedId} onSelect={this.handleOnSelected} showSearch={true}
                                   order={this.state.orderMode || deviceType === HC_CONST.SCR_DESCKTOP} onSetOrderDown={this.setOrderDown} onSetOrderUp={this.setOrderUp}/>
                </div>
                <div className={contentClass}>
                    <div className="hc-internal-panel">
                        <TopPanel text={header} licon={licon} ricon={ricon} onLiconClick={liconAction}
                                  onRiconClick={riconAction} EnableMenuText={showMenuText} liconText={HC_LANG.DUE_CANCEL}
                                  riconText={HC_LANG.DUE_SAVE}
                                  rbutton={rbutton}/>
                        {control}
                    </div>
                </div>
            </div>
        );
    }
});


// WEBPACK FOOTER //
// ./documents.js